import LayersClearIcon from "@mui/icons-material/LayersClear";
import {
  Box,
  CircularProgress,
  IconButton,
  IconButtonProps,
  Tooltip,
} from "@mui/material";
import { useEventEditorContext } from "./EventEditorContext";
export interface ActivateEventsButtonProps extends IconButtonProps {}
export default function CancelEventsButton(props: ActivateEventsButtonProps) {
  const {
    groupEventCancel,
    groupEventGroupCancel,
    loadingState,
    groupEditMode,
    groupActionsEnabled,
  } = useEventEditorContext();

  return (
    <Tooltip
      title={
        groupEditMode === "event"
          ? "Események visszavonása"
          : "Hajó indulás események visszavonása"
      }
    >
      <Box>
        <IconButton
          color="warning"
          onClick={
            groupEditMode === "event" ? groupEventCancel : groupEventGroupCancel
          }
          disabled={!groupActionsEnabled}
          {...props}
        >
          {loadingState === "groupEventCancel" ||
          loadingState === "groupEventGroupCancel" ? (
            <CircularProgress size={16} />
          ) : (
            <LayersClearIcon />
          )}
        </IconButton>
      </Box>
    </Tooltip>
  );
}
